import React, { useEffect, useState } from "react";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
// import PatientsTable from "../tables/PatientsTable";
import { RiCalendar2Fill } from "react-icons/ri";
import { AiOutlinePlus } from "react-icons/ai";
import { useNavigate } from "react-router-dom";
import { get } from "../../utility/fetch";
import TagInputs from "../layouts/TagInputs";
// import ReferralModal from "../modals/RefferalModal";
import Spinner from "../UI/Spinner";
import { usePatient } from "../../contexts";
import Pagination from "../layouts/Pagination";
import ClientList from "../layouts/ClientList";
import WalkInModal from "../modals/WalkInModal";
import WalkInTable from "../layouts/WalkInTable";
import Personal from "./Patient/Personal";
import QueuedWalkInTable from "../tables/QueuedWalkInTable";
import { Skeleton } from "@mui/material";
import TableSkeleton from "../tables/TableSkeleton";
// import VitalPatientsTable from "../tables/VitalPatientTable";
// import AdmitCheck from "./Patient/AdmitCheck";
// import PatientsAppointTable from "../tables/PatientsAppointTable";

function WalkInPatients() {
  const [allPatients, setAllPatients] = useState([]);
  const [vitalPatients, setVitalPatients] = useState([]);
  const [selectedDate, setSelectedDate] = useState(new Date());
  const [payload, setPayload] = useState('');
  const [filterSelected, setFilterSelected] = useState("firstName");
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [loading, setLoading] = useState(true);
  const [queuedloading, setQueuedLoading] = useState(true);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [totalPagesVital, setTotalPagesVital] = useState(1);
  const [searchTerm, setSearchTerm] = useState('');
  const [admittedPatients, setAdmittedPatients] = useState([])
  const [appointPatients, setAppointPatients] = useState([])
  const [allPending, setAllPending] = useState([])
  const [checkinPatients, setCheckinPatients] = useState(false)
  const [nurseTypes, setNurseTypes] = useState('admin');
  const [selectedTab, setSelectedTab] = useState('walkin');
  const [allWalkIn, setAllWalkIn] = useState([]);




  const itemsPerPage = 10;

  const { setHmoDetails, patientId, nurseRoles } = usePatient();

  const handlePageChange = (newPage) => {
    //  setLoading(true);
    if (newPage > 0 && newPage <= totalPages) {
      setCurrentPage(newPage);
      if (payload) {
        searchPatients(payload, newPage);
      } else {
        getAllPatients(newPage);
      }
    }
    //  setLoading(false);
  };

  const generatePageNumbers = (currentPage, totalPages) => {
    let pages = [];
    if (totalPages <= 5) {
      for (let i = 1; i <= totalPages; i++) {
        pages.push(i);
      }
    } else {
      if (currentPage <= 3) {
        pages = [1, 2, 3, 4, totalPages];
      } else if (currentPage >= totalPages - 2) {
        pages = [1, totalPages - 3, totalPages - 2, totalPages - 1, totalPages];
      } else {
        pages = [1, currentPage - 1, currentPage, currentPage + 1, totalPages];
      }
    }
    return pages;
  };

  const closeModal = () => {
    getAllPatients();
    setIsModalOpen(false);
  };

  const selectRecord = () => () => {
    setIsModalOpen(true);
  };

  const handleDateChange = (date) => {
    setSelectedDate(date);
  };

  let navigate = useNavigate();

  const formatDate = (dateString) => {
    const date = new Date(dateString);
    const day = String(date.getDate()).padStart(2, '0');
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const year = date.getFullYear();

    return `${day}-${month}-${year}`;
  };

  const isToday = (date) => {
    const today = new Date();
    return (
      date.getDate() === today.getDate() &&
      date.getMonth() === today.getMonth() &&
      date.getFullYear() === today.getFullYear()
    );
  };


  const renderTabContent = (selectedTab) => {
    switch (selectedTab) {
      case "walkin":
        return <WalkInTable data={allPatients} loading={loading} currentPage={currentPage} itemsPerPage={itemsPerPage} />;
      case "queue":
        return <QueuedWalkInTable loading={queuedloading} getProcedures={getAllPatients} data={allWalkIn} readOnly={false} />
      default:
        return <Personal setSelectedTab={setSelectedTab} renderTabContent={renderTabContent} />;
    }
  };

  const CustomInput = ({ value, onClick }) => (
    <button
      onClick={onClick}
      onKeyDown={(e) => e.preventDefault()}
      className="custom-datepicker-input flex gap-6 flex-v-center"
    >
      {isToday(selectedDate) ? "Today" : formatDate(selectedDate)}
      <RiCalendar2Fill />
    </button>
  );

 

  const getAllPatients = async (currentPage=1) => {
    setLoading(true);
    try {
      let res = await get(`/walkinpatient/list/true/UnPaid?filterQuery=''&pageNumber=${currentPage}&pageSize=${itemsPerPage}`);
      console.log(res)
      setAllPatients(res?.data?.recordList);
      setTotalPages(res?.data?.metadata?.totalPages);
    } catch (error) {
      console.error('Error fetching all patients:', error);
    } finally {
      setLoading(false);
    }

  };

  // const getAllPending = async () => {
  //   setLoading(true);
  //   try {
  //     let res = await get(`/walkinlabrequest/list/${currentPage}/${itemsPerPage}`);
  //     console.log(res)
  //     setAllPending(res?.data?.recordList);
  //     setTotalPages(res?.data?.metadata?.totalPages);
  //   } catch (error) {
  //     console.error('Error fetching all pending patients:', error);
  //   } finally {
  //     setLoading(false);
  //   }
  // };

 
  

  const searchPatients = async (searchParam, page = 1) => {
    setLoading(true);
    try {
      let url =  `/walkinpatient/list/true/${filterSelected}?filterQuery=${searchParam}&pageNumber=${page}&pageSize=${itemsPerPage}`;
     
      // if (filterSelected) {
      //   url += `${filterSelected}=${searchParam}&`;
      // }
      // url += `pageIndex=1&pageSize=100`;
      let res = await get(url);
      setAllPatients(res?.data?.recordList);
      setTotalPages(res?.data?.metadata?.totalPages);
    } catch (error) {
      console.error('Error fetching all patients:', error);
    } finally {
      setLoading(false);
    }
  };

  const handleChange = (event) => {
    const { name, value } = event.target;
    if (name === "filter") {
      setFilterSelected(value);
    } else if (name === 'searchDate') {
      const formattedDate = formatDate(value);
      setSearchTerm(value)
    } else {
      setPayload(value);
    }
  };

  useEffect(() => {
    getAllPatients();
  }, []);



  const handleSearchClick = () => {
    setCurrentPage(1);
    searchPatients(payload, 1);
  };

  const filterOptions = [
    { value: "All", name: "All" },
    { value: "Name", name: "Name" },
    { value: "Email", name: "Email" },
    { value: "PhoneNumber", name: "Phone Number" },
    { value: "patientRef", name: "Lab Id"},
  ];


  // const getAllPatients = async () => {
  //   setQueuedLoading(true);
  //   let res = await get('/walkinlabrequest/list/1/10/un-paid')

  //   if (res?.statusCode === 200) {
  //     // notification({ message: res?.data?.message, type: "success" });
  //     setAllWalkIn(res.data?.recordList);
  //     setTotalPages(res?.metadata?.pageCount);
  //     console.log(res)
  //     setQueuedLoading(false);
  //   }
  //   else {
  //     // console.error('Error fetching all patients:', res?.data?.message);
  //     setQueuedLoading(false);
  //     // notification({ message: res?.data?.message, type: "error" });
  //   }
  //   console.log(res)
  // }


  return (
    <div className="w-100 m-t-40">
      {(
        <>
          <h1 className="m-t-20">Walk-In Patients</h1>
        
          <div className="flex flex-v-center flex-h-end gap-8">
            {/* <div className=""> */}
            <TagInputs onChange={handleChange} name="firstName" label="Find Patient" />
            {/* </div> */}
            {/* <div className="flex flex-v-center "> */}
            <TagInputs
              onChange={handleChange}
              name="filter"
              type="select"
              options={filterOptions}
            />
            <div className="m-t-10">
              <button onClick={() => { setCurrentPage(1); searchPatients(payload, 1); }} className="btn" style={{height: '40px'}}>Search</button>
            </div>
            {/* </div> */}
            {/* <div className="   m-t-10">
              <button onClick={() => { setIsModalOpen(true); }} className="btn no-wrap flex flex-h-center gap-10 flex-v-center">
                <>
                  <AiOutlinePlus size={24} color="white" />
                  <p className=" m-r-10 no-wrap">Check in a Patient</p>
                </>
              </button>
            </div> */}

          </div>

          {/* <WalkInTable data={allPatients} currentPage={currentPage} itemsPerPage={itemsPerPage} />
             */}

          <div>
            {renderTabContent(selectedTab)}
          </div>

          <Pagination
            currentPage={currentPage}
            totalPages={totalPages}
            handlePageChange={handlePageChange}
            generatePageNumbers={generatePageNumbers}
          />
        </>
      )}

      {isModalOpen &&
        <WalkInModal
          closeModal={closeModal}
        />
      }
    </div>

  );
}

export default WalkInPatients;
